import React from "react";
import Sidebar from "../../components/jsx/dashboard/sidebar/SideBar";
import FeesDue from "../../components/jsx/dashboard/FeesDue";
import EnrolledCourses from "../../components/jsx/dashboard/enrolledCourses/EnrolledCourses";
import dashboardIcon from "../..//assets/dashboard/dashboard.svg";
import StudentProfileCard from "../../components/jsx/dashboard/StudentProfile/StudentProfile";
import StudentPortalList from "../../components/jsx/dashboard/StudentPortalList/StudentPortalCard";
import PerformanceCard from "../../components/jsx/dashboard/statscard/Stats";
import PageContainerLayout from "../../components/layout/PageContainer/PageContainerLayout";
import { useAuth } from "../../context/AuthContext";

const DashboardPage = () => {
  const { currentUser } = useAuth();

  // Get first name from currentUser or use a default greeting
  const firstName = currentUser?.firstName || '';
  const greeting = firstName ? `Welcome, ${firstName}` : 'Welcome';

  // Create breadcrumbs for dashboard
  const breadcrumbs = [
    { label: 'Home', path: '/dashboard', active: false },
    { label: 'Dashboard', path: '/dashboard', active: true }
  ];

  // Create right content section for FeesDue
  const rightContent = (
    <div className="mt-0 p-0">
      {/* <FeesDue apiEndpoint="/api/fees" /> */}
    </div>
  );

  return (
    <PageContainerLayout
      title={greeting}
      icon={dashboardIcon}
      breadcrumbs={breadcrumbs}
      rightContent={rightContent}
    >
      {/* Main Content - Responsive Grid */}
      <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-14 gap-4 lg:gap-6">
        {/* Left Section - Profile & Portal */}
        <div className="col-span-1 md:col-span-4 lg:col-span-4 flex flex-col gap-4 lg:gap-8">
          <div className="flex-none">  {/* Prevents the profile card from growing */}
            <StudentProfileCard />
          </div>
          <div className="flex-grow">  {/* Allows the portal list to take remaining space */}
            <StudentPortalList />
          </div>
        </div>

        {/* Middle Section - Courses & Performance */}
        <div className="col-span-1 md:col-span-4 lg:col-span-7 flex flex-col gap-4">
          <div className="flex-none">  {/* Prevents the enrolled courses from growing too much */}
            <EnrolledCourses />
          </div>
          <div className="flex-grow">  {/* Allows the performance card to take remaining space */}
            <PerformanceCard />
          </div>
        </div>

        {/* Right Section - Sidebar */}
        {/* Sidebar for mobile and tablet screens (hidden on large screens) */}
        <div className="block lg:hidden col-span-1 md:col-span-8">
          <Sidebar />
        </div>

        {/* Sidebar for large screens only */}
        <div className="hidden lg:block col-span-1 lg:col-span-3">
          <Sidebar />
        </div>
      </div>
    </PageContainerLayout>
  );
};

export default DashboardPage;
